var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { "margin-top": "30px" } }, [
        _c("h1", { staticStyle: { display: "inline" } }, [
          _vm._v(_vm._s(_vm.$t("booking.menu.mapping")))
        ])
      ]),
      _c("booking-menu"),
      _c("v-row"),
      _c(
        "v-card-title",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { md: "3", sm: "5", cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("global.search"),
                      "append-icon": "search",
                      "hide-details": "",
                      "single-line": ""
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title"),
              _c(
                "v-card-text",
                [
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("booking.dateShort"),
                      value: _vm.formatDateView(
                        _vm.dialogBooking.creation_date
                      ),
                      filled: "",
                      readonly: ""
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("booking.other.serviceName"),
                      filled: "",
                      readonly: ""
                    },
                    model: {
                      value: _vm.dialogBooking.type,
                      callback: function($$v) {
                        _vm.$set(_vm.dialogBooking, "type", $$v)
                      },
                      expression: "dialogBooking.type"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("booking.numberShort"),
                      filled: "",
                      readonly: "",
                      value:
                        _vm.dialogBooking.is_cancelled === 1
                          ? _vm.dialogBooking.reservation_number +
                            " (" +
                            _vm.$t("booking.canceled") +
                            ")"
                          : _vm.dialogBooking.reservation_number
                    }
                  }),
                  _c("v-text-field", {
                    staticStyle: { "text-transform": "capitalize" },
                    attrs: {
                      label: _vm.$t("booking.passenger"),
                      filled: "",
                      readonly: ""
                    },
                    model: {
                      value: _vm.dialogBooking.passengers,
                      callback: function($$v) {
                        _vm.$set(_vm.dialogBooking, "passengers", $$v)
                      },
                      expression: "dialogBooking.passengers"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("booking.orderingPerson"),
                      filled: "",
                      readonly: ""
                    },
                    model: {
                      value: _vm.dialogBooking.orderingPerson,
                      callback: function($$v) {
                        _vm.$set(_vm.dialogBooking, "orderingPerson", $$v)
                      },
                      expression: "dialogBooking.orderingPerson"
                    }
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("booking.price"),
                      value: _vm.dialogBooking.total_amount,
                      filled: "",
                      readonly: "",
                      suffix: "PLN"
                    }
                  }),
                  _c("v-autocomplete", {
                    attrs: {
                      items: _vm.formattedAvailableUsers,
                      label: _vm.$t("booking.assignedPersons"),
                      multiple: "",
                      outlined: ""
                    },
                    model: {
                      value: _vm.dialogBooking.assignedPersons,
                      callback: function($$v) {
                        _vm.$set(_vm.dialogBooking, "assignedPersons", $$v)
                      },
                      expression: "dialogBooking.assignedPersons"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled: _vm.$store.getters["Ajax/loading"],
                        color: "blue darken-1",
                        text: ""
                      },
                      on: { click: _vm.save }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.save")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          "custom-filter": _vm.filterOverAllProperty,
          headers: _vm.headers,
          items: _vm.bookings,
          search: _vm.search,
          "sort-by": _vm.pagination.sortBy,
          "sort-desc": _vm.pagination.descending
        },
        on: {
          "update:sortDesc": function($event) {
            return _vm.$set(_vm.pagination, "descending", $event)
          },
          "update:sort-desc": function($event) {
            return _vm.$set(_vm.pagination, "descending", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(props) {
              return [
                _c("tr", [
                  _c("td", {}, [
                    _vm._v(_vm._s(_vm.formatDateView(props.item.creation_date)))
                  ]),
                  _c("td", [_vm._v(_vm._s(props.item.type))]),
                  _c(
                    "td",
                    [
                      _vm._v(" " + _vm._s(props.item.reservation_number) + " "),
                      props.item.is_cancelled === 1
                        ? _c(
                            "v-chip",
                            {
                              staticStyle: {
                                color: "#FFE3F3",
                                "background-color": "#ff99d0 !important"
                              },
                              attrs: { label: "", outlined: "", small: "" }
                            },
                            [_vm._v(_vm._s(_vm.$t("booking.canceled")) + " ")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticStyle: { "text-transform": "capitalize" } },
                    [_vm._v(_vm._s(props.item.passengers))]
                  ),
                  _c("td", [_vm._v(_vm._s(props.item.orderingPerson))]),
                  _c(
                    "td",
                    _vm._l(props.item.assignedPersons, function(userId) {
                      return _c("span", { key: userId }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.availableUsers.find(function(v) {
                                return v.id === userId
                              }).name
                            ) +
                            " " +
                            _vm._s(
                              _vm.availableUsers.find(function(v) {
                                return v.id === userId
                              }).surname
                            ) +
                            " ("
                        ),
                        _c("b", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.availableUsers.find(function(v) {
                                  return v.id === userId
                                }).login
                              )
                          )
                        ]),
                        _vm._v(") "),
                        _c("br")
                      ])
                    }),
                    0
                  ),
                  _c(
                    "td",
                    { staticClass: "datatable-total-amount" },
                    [
                      _vm._v(" " + _vm._s(props.item.total_amount) + " "),
                      props.item.total_amount != null
                        ? [_vm._v("PLN")]
                        : _vm._e()
                    ],
                    2
                  ),
                  _c(
                    "td",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.openDialog(
                                                    props.item
                                                  )
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v("fa-user-tag")
                                            ])
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("booking.assignUsers")) +
                                  " "
                              )
                            ]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.parseUsers(
                                                    props.item.id
                                                  )
                                                }
                                              }
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v("fa-users-cog")
                                            ])
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("booking.parseUsers")) + " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }